import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import flowRight from 'lodash-es/flowRight';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import { useDescope } from '@descope/react-sdk';

import styles from './account-menu.styles';
import account from './account.svg?url';
import useSession from 'core/hooks/use-session';
import { signOut as cognitoLogout } from 'core/components/auth';
import PermissionsModal from './permissions-modal';

const AccountMenu = ({ classes }) => {
  const { logout: descopeLogout } = useDescope();
  const { canViewTools, isInternalAgent } = useSession();
  const [userMenuEl, setUserMenuEl] = useState(null);
  const [permissionsModalOpen, setPermissionsModalOpen] = useState(false);
  const history = useHistory();

  const handleClick = (event) => {
    setUserMenuEl(event.currentTarget);
  };

  const handleClose = () => {
    setUserMenuEl(null);
  };

  const handleToolsReroute = () => {
    history.push('/staff/tools');
  };

  const handleLogout = async () => {
    await cognitoLogout();
    await descopeLogout();
  };

  const goToProfile = () => {
    history.push('/profile');
  };

  return (
    <>
      <IconButton
        color="primary"
        aria-label="Profile"
        className={classes.buttonUser}
        onClick={handleClick}
        data-cy="menu"
      >
        <img src={account} alt="account" />
      </IconButton>
      <Menu anchorEl={userMenuEl} open={Boolean(userMenuEl)} onClose={handleClose} onClick={handleClose}>
        <MenuItem onClick={goToProfile}>Profile</MenuItem>
        {canViewTools && <MenuItem onClick={handleToolsReroute}>Tools</MenuItem>}
        {/* Internal users only — external agency users effectively just have ExternalSales (#31758) */}
        {isInternalAgent && <MenuItem onClick={() => setPermissionsModalOpen(true)}>Permissions</MenuItem>}
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
      {/* Rendered outside the Menu — the Menu closes itself on any item click */}
      {isInternalAgent && (
        <PermissionsModal open={permissionsModalOpen} onClose={() => setPermissionsModalOpen(false)} />
      )}
    </>
  );
};

AccountMenu.propTypes = {
  classes: PropTypes.object.isRequired
};

export default flowRight(withStyles(styles))(AccountMenu);
